import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';

import { User } from '../_models/index';
import { DemoService } from '../demo.service';
import { IdleService } from '../services/idle.service';
import { HttpClient } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';
import { GlobalFunctionsService } from '../services/global-functions.service';
import { MysqlService } from '../services/mysql.service';
// import { UserService } from '../_services/index';

@Injectable()
export class AgentGuard implements CanActivate {

    currentUserVAR!: User;
    users: User[] = [];
    brand_user: Object;
    force_logout: any;

    all_router_details: string;
    current_base_route: string;
    ipAddress: { ip: string; };
  force_logout_soft: any;
  log_name: string;
  log_data: any;

    constructor(private router: Router,
        private _demoService: DemoService,
        private idleService: IdleService,
        public _mysqlService: MysqlService ,       private toastr: HotToastService,   
        private route: ActivatedRoute,
       private gfunc: GlobalFunctionsService,
       private http: HttpClient
        ) { }



    // Session Storage: Browser
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (sessionStorage.getItem('currentUser') as string as string) {
            // logged in so return true
                // check the user level
                this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser') as string);
                // console.log('Access Level: ', this.currentUser.access_level);
                // tslint:disable-next-line:prefer-const
                let current_access_level = this.currentUserVAR.access_level;
            // see if Staff
            if (current_access_level === '5' ) {
            // this.router.navigate(['/staff'], { queryParams: { returnUrl: state.url }});

                // Do Force Logout Check. FIRST...
                this.getUser_FLO_Check(this.currentUserVAR.user_id)
                this.getUser_FLO_Check_SOFT(this.currentUserVAR.user_id) // new automated to make a user logout and refresh next time they login.


            return true;
            }else {
            return false; // user not an Staff
             }
        }

        // not logged in so redirect to login page with the return url
       // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        this.router.navigate(['/logout'], { queryParams: { returnUrl: state.url }});
        return false;
    }




// Database Functions
getUser_FLO_Check(user_id) {
    this._demoService.getBrandUser(user_id).subscribe(
       data => { this.brand_user = data;
      let res = data[0];
      this.force_logout = res.force_logout;
  
              console.log('FLO:Check:: AUTH GUARD ' + this.force_logout)
              // ######  FORCE LOGOUT
                // see if I can initiate the timer code I already have.
                if(this.force_logout == 1){
                  // if(this.gfunc.sessionUserId == '108'){
                  this.idleService.init(0); // FLO
                  // or kill and go direct and fource this user to logout.
                  // this.router.navigate(['/logout'], { queryParams: { }});

            this.router.navigate(['/logout'], { queryParams: {}}); // can I simply set a param

                //   sessionStorage.removeItem('currentUser');
                //   localStorage.removeItem('currentUser');
                //   sessionStorage.removeItem('currentUser');
                //   sessionStorage.removeItem('sessionBrandName');
                //   sessionStorage.removeItem('sessionBrandTypeId');

                // this.setUserForceLogout(res, user_id, 0) // set to auto fix so that I can reset the entire system at once....
                this.setUserForceLogout(res, user_id, 1) // fource loop
                
                } else{
                 this.idleService.init(1200); // in seconds; // 10 mins = 600 seconds at idle
                }
  
  
      },
       err => console.error(err),
       () => {
          
              
        // SO20 -- NEW USER JSON LOGGING FUNCTION
        // need to add this as routes does not work globally
              this.all_router_details = this.router.url;
              this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));

              this.http.get<{ip:string}>('https://jsonip.com')
              .subscribe( data => {
                // console.log('th data', data);
                this.ipAddress = data
              })

              let model = {
                route: this.current_base_route,
                app_ip: this.ipAddress,
                user_id: this.currentUserVAR.user_id,
                app_timestamp: this.gfunc.today,
                user_level: this.gfunc.sessionUserLevel,
                brand_type_id: this.gfunc.sessionBrandTypeId,
                brand_id: this.gfunc.sessionBrandId,
                app_base_route: this.gfunc.current_base_route,
                app_route_id: '' // not yet established in the system structure.
               }
              this.route_log_agent(model)
        
        console.log('done loading user for update')}
     );
   }


// Ability to log user user out and activate once logged out, so they can automatically login.
   getUser_FLO_Check_SOFT(user_id) {
    this._demoService.getBrandUser(user_id).subscribe(
       data => { this.brand_user = data;
      let res = data[0];
      this.force_logout_soft = res.force_logout_soft;
  
              console.log('FLO:Check:: AUTH GUARD SOFT ' + this.force_logout_soft)
              // ######  FORCE LOGOUT
                // see if I can initiate the timer code I already have.
                if(this.force_logout_soft == 1){
                  // if(this.gfunc.sessionUserId == '108'){
           this.idleService.init(0); // FLO
                  // or kill and go direct and fource this user to logout.
                  this.router.navigate(['/logout'], { queryParams: {soft:1 }});
                //   sessionStorage.removeItem('currentUser');
                //   localStorage.removeItem('currentUser');
                //   sessionStorage.removeItem('currentUser');
                //   sessionStorage.removeItem('sessionBrandName');
                //   sessionStorage.removeItem('sessionBrandTypeId');
                
                this.setUserForceLogoutSoft(res, user_id, 0) // set abck to normal -- set so it automacally sets back for next login.

                } else{
                 this.idleService.init(1200); // in seconds; // 10 mins = 600 seconds at idle
                }
  
  
      },
       err => console.error(err),
       () => {
          
              
        // SO20 -- NEW USER JSON LOGGING FUNCTION
        // need to add this as routes does not work globally
                    // this.all_router_details = this.router.url;
                    // this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));

                    // this.http.get<{ip:string}>('https://jsonip.com')
                    // .subscribe( data => {
                    //   // console.log('th data', data);
                    //   this.ipAddress = data
                    // })

                    // let model = {
                    //   route: this.current_base_route,
                    //   app_ip: this.ipAddress,
                    //   user_id: this.currentUserVAR.user_id,
                    //   app_timestamp: this.gfunc.today,
                    //   user_level: this.gfunc.sessionUserLevel,
                    //   brand_type_id: this.gfunc.sessionBrandTypeId,
                    //   brand_id: this.gfunc.sessionBrandId,
                    //   app_base_route: this.gfunc.current_base_route,
                    //   app_route_id: '' // not yet established in the system structure.
                    //  }
                    // this.route_log_agent(model)
        
        console.log('done loading user for update')}
     );
   }




   // new route logger to file for each user.
route_log_agent(model) {
  this._demoService.route_log_agent(model).subscribe(
     data => {
     // console.log(model);
       // this.trace_candidate_update = data;
    //  this.toastr.success('User Route Logged');

      // console.log('LogModel: ' + JSON.stringify(model))
     // Subject to reload the manager component parent.
    //  this.closeParentModel.emit();
     // CreateJobTypeComponent.returned.next(false);
   //    return true;
     },
     error => {
      // this.toastr.error('User Route Logging ERROR');
      //  console.error('Error Saving Project Figures!');
      //  return console.error(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
  );
  }









// AUTOMATED TO LOG THE USER OUT ONCE AND THEN ALLOW ACCESS AGAIN
setUserForceLogoutSoft(model, user_id, force_logout_soft)  {

  this._demoService.setUserForceLogoutSoft(model, user_id, force_logout_soft) .subscribe(
     data => {
      // console.log(model);
       // this.trace_candidate_update = data;
     this.toastr.success('User FLO Status Updated');

     if(force_logout_soft == 1){
      this.log_name = 'FLO, User Forced To Logout SOFT MODE ON: ' + model.user_id + ' USER :: '
      + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

              // insert log
        this.log_data = {
                // log_id: null,
                log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                log_action: 'forced_logout_ON', // automated / updated / created / uploaded / link_created / sent / accessed
                log_type_id: 28, // see datatable system_log_types (12 = subject_attempt)
                // created_by: this.sessionUserId,
                created_by: model.user_id,
                created_date: this.gfunc.today,
                subject_id: model.file_subject_id,
                job_id: model.file_job_id,
                job_reference_number: model.job_reference_number,
                file_number: model.file_number,
                reference_number: model.reference_number,
                subject_number: model.file_subject_number,
                brand_id: model.brand_id,
                user_id: model.user_id,
            
                created_level: model.created_level, // staff
                brand_type_id: model.brand_type_id,
                subject_com_type_id: model.subject_com_type_id,
                subject_template_doc_id: model.subject_template_doc_id,
                log_name: this.log_name,
              file_id: model.file_id,
              agent_id: null,
              invoice_id: null,
              };



     }else{
      this.log_name = 'FLO, User Soft Forced MODE OFF  ' + model.user_id + ' USER :: '
      + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

          // insert log
          this.log_data = {
            // log_id: null,
            log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
            log_action: 'forced_logout_soft_OFF', // automated / updated / created / uploaded / link_created / sent / accessed
            log_type_id: 29, // see datatable system_log_types (12 = subject_attempt)
            // created_by: this.sessionUserId,
            created_by: model.user_id,
            created_date: this.gfunc.today,
            subject_id: model.file_subject_id,
            job_id: model.file_job_id,
            job_reference_number: model.job_reference_number,
            file_number: model.file_number,
            reference_number: model.reference_number,
            subject_number: model.file_subject_number,
            brand_id: model.brand_id,
            user_id: model.user_id,
        
            created_level: model.created_level, // staff
            brand_type_id: model.brand_type_id,
            subject_com_type_id: model.subject_com_type_id,
            subject_template_doc_id: model.subject_template_doc_id,
            log_name: this.log_name,
          file_id: model.file_id,
          agent_id: null,
          invoice_id: null,
          };


     }


   this.gfunc.createSystemLog(this.log_data);


    //  this.getUserById(this.user_id);
     // Subject to reload the manager component parent.
    // BrandUserManagerComponent.returned.next(false);
       return true;
     },
     error => {
       console.error('Error saving User!');
      // this.getUserById(this.user_id);
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
  );
  }



// update was here for onit but moved for onchange
setUserForceLogout(model, user_id, force_logout)  {

  this._demoService.setUserForceLogout(model, user_id, force_logout) .subscribe(
     data => {
      // console.log(model);
       // this.trace_candidate_update = data;
     this.toastr.success('User FLO Status Updated');

     if(force_logout == 1){
      this.log_name = 'FLO, User Forced To Logout MODE ON: ' + model.user_id + ' USER :: '
      + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

              // insert log
        this.log_data = {
                // log_id: null,
                log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                log_action: 'forced_logout_ON', // automated / updated / created / uploaded / link_created / sent / accessed
                log_type_id: 28, // see datatable system_log_types (12 = subject_attempt)
                // created_by: this.sessionUserId,
                created_by: model.user_id,
                created_date: this.gfunc.today,
                subject_id: model.file_subject_id,
                job_id: model.file_job_id,
                job_reference_number: model.job_reference_number,
                file_number: model.file_number,
                reference_number: model.reference_number,
                subject_number: model.file_subject_number,
                brand_id: model.brand_id,
                user_id: model.user_id,
            
                created_level: model.created_level, // staff
                brand_type_id: model.brand_type_id,
                subject_com_type_id: model.subject_com_type_id,
                subject_template_doc_id: model.subject_template_doc_id,
                log_name: this.log_name,
              file_id: model.file_id,
              agent_id: null,
              invoice_id: null,
              };



     }else{
      this.log_name = 'FLO, User Forced MODE OFF  ' + model.user_id + ' USER :: '
      + ' - ' + model.username + ' (' + model.first_name + ' ' + model.surname + ' ' + model.email_address +  ' ) ';

          // insert log
          this.log_data = {
            // log_id: null,
            log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
            log_action: 'forced_logout_OFF', // automated / updated / created / uploaded / link_created / sent / accessed
            log_type_id: 29, // see datatable system_log_types (12 = subject_attempt)
            // created_by: this.sessionUserId,
            created_by: model.user_id,
            created_date: this.gfunc.today,
            subject_id: model.file_subject_id,
            job_id: model.file_job_id,
            job_reference_number: model.job_reference_number,
            file_number: model.file_number,
            reference_number: model.reference_number,
            subject_number: model.file_subject_number,
            brand_id: model.brand_id,
            user_id: model.user_id,
        
            created_level: model.created_level, // staff
            brand_type_id: model.brand_type_id,
            subject_com_type_id: model.subject_com_type_id,
            subject_template_doc_id: model.subject_template_doc_id,
            log_name: this.log_name,
          file_id: model.file_id,
          agent_id: null,
          invoice_id: null,
          };


     }


   this.gfunc.createSystemLog(this.log_data);


    //  this.getUserById(this.user_id);
     // Subject to reload the manager component parent.
    // BrandUserManagerComponent.returned.next(false);
       return true;
     },
     error => {
       console.error('Error saving User!');
      //  this.getUserById(this.user_id);
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
  );
  }
 




}
